/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import ReactSelect, { components } from 'react-select';

// COMPONENTS
import Icon from '../Icon/Icon';

// ENUMS
import { Icons } from '../../enums/icons';

// INTERFACES
import { ISelect } from '../../interfaces/Select.interface';

// STYLES
import { Label, Container, SubLabelText, SelectContainer, Error, defaultStyles } from './styles';

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <Icon type={Icons.ARROW_DOWN} />
    </components.DropdownIndicator>
  );
};

const Select: React.FC<ISelect> = forwardRef(
  (
    {
      classNamePrefix,
      customStyles,
      defaultValue,
      externalError,
      id,
      isDisabled = false,
      isSearchable = false,
      label,
      mask,
      maskChar,
      name,
      onBlur,
      onChange,
      options,
      placeholder = 'Escolha uma opção',
      subLabel,
      value,
      inputRef
    }: ISelect,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref?: any
  ) => {
    return (
      <>
        <Container>
          <Label htmlFor={name} isErroredExternal={!!externalError} isDisabled={isDisabled}>
            {label}
          </Label>

          {!!subLabel && <SubLabelText>{subLabel}</SubLabelText>}

          <SelectContainer>
            {!!externalError && <Error title={externalError}>{externalError}</Error>}

            <ReactSelect
              id={id}
              inputId={id}
              components={{ DropdownIndicator }}
              isClearable={false}
              isDisabled={isDisabled}
              isErroredExternal={!!externalError}
              isSearchable={isSearchable}
              mask={mask}
              maskChar={maskChar}
              menuPlacement="bottom"
              name={name}
              value={value || defaultValue}
              onBlur={onBlur}
              onChange={onChange}
              options={options}
              placeholder={placeholder}
              classNamePrefix={classNamePrefix}
              inputRef={inputRef}
              ref={ref}
              styles={customStyles || defaultStyles}
            />
          </SelectContainer>
        </Container>
      </>
    );
  }
);

export default Select;
